import React from "react";
import { slides } from "../../constants";

class Slider extends React.Component {
  render() {
    return (
      <>
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-ride="carousel"
        >
          <ol className="carousel-indicators">
            {slides.map((i, index) => (
              <li
                key={index}
                data-target="#carouselExampleIndicators"
                data-slide-to={index}
                className={`${index === 0 && "active"}`}
              ></li>
            ))}
          </ol>

          <div className="carousel-inner">
            {slides.map((i, index) => (
              <div
                key={index}
                className={`carousel-item ${index === 0 && "active"}`}
              >
                <img className="d-block w-100 slider" src={i} alt="slide" />
              </div>
            ))}
          </div>
        </div>
      </>
    );
  }
}

export default Slider;
